import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const SwitchBox = styled(Box)`
  width: 100%;
`
